/* global globalThis */

export const isAuthPortalEnabled = () =>
  process.env.REACT_APP_AUTH_PORTAL_ENABLED === 'true';

export const buildAuthPortalUrl = (path, { returnTo, search } = {}) => {
  const params = new URLSearchParams(
    search ?? globalThis.location?.search ?? '',
  );
  const legacyRedirect = params.get('redirect');
  const redirectPath = legacyRedirect?.startsWith('/') ? legacyRedirect : null;

  if (redirectPath) {
    params.delete('redirect');
  }

  const target = returnTo ?? redirectPath;
  if (target) {
    params.set('returnTo', target);
  }

  const query = params.toString();
  return query ? `${path}?${query}` : path;
};
